module.exports = __webpack_public_path__ + "img/DirectionsCarFilledFilled.bec60851.svg";